var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$options.name,
    ( _obj = {}, _obj[("" + _vm.styleClass)] = _vm.styleClass, _obj )]},[(this.$store.state.article.locations.length)?_c('span',{staticClass:"prefix"},[_vm._v("\n    "+_vm._s(_vm.__('in'))+" \n  ")]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.listLocations())}})])}
var staticRenderFns = []

export { render, staticRenderFns }